jQuery(function($){
    if ($('.switch').length == 0){
        return;
    }

    $(document).on('click', '[data-switch]', function(){
        input = $(this).find('input');

        if (input.is(':checked')){
            input.prop('checked', false);
            input.trigger('change');
        }
        else{
            input.prop('checked', true);
            input.trigger('change');
        }
    });
});